const getters = {
  sidebar: state => state.app.sidebar,
  accessToken: state => state.auth.accessToken,
  permissions: state => ((state.auth.userData?.role?.options || '').split(',')),
  userData: state => state.auth.userData || {},
  pageLoading: state => state.app.pageLoading,
  fullscreenLoading: state => state.app.fullscreenLoading,
}
export default getters
